<template>
  <footer id="mainFooter">
    <div class="px-md-4 mx-md-4">
      <p class="footer-tagline text-center mb-3">
        Free music and sound effects for videos, podcasts, streams, and creative projects.
      </p>
      <div class="d-flex footer-menu justify-content-center mb-2 flex-wrap" aria-label="Primary footer links">
        <a href="/" class="mx-2 mx-md-4 px-md-4 mb-2">Home</a>
        <router-link to="/music" class="mx-2 mx-md-4 px-md-4 mb-2">Music</router-link>
        <router-link to="/soundeffects" class="mx-2 mx-md-4 px-md-4 mb-2">Sound Effects</router-link>
        <a href="https://blog.viberary.com/" class="mx-2 mx-md-4 px-md-4 mb-2">Blogs</a>
        <router-link to="/about" class="mx-2 mx-md-4 px-md-4 mb-2">About</router-link>
        <router-link to="/faq" class="mx-2 mx-md-4 px-md-4 mb-2">FAQ</router-link>
      </div>
      <div class="footer-guides text-center mb-3" aria-label="Creator guides">
        <span>Creator guides:</span>
        <router-link to="/free-music-for-youtube-creators">YouTube</router-link>
        <router-link to="/free-music-for-commercial-use">Commercial use</router-link>
        <router-link to="/free-music-for-podcasts">Podcasts</router-link>
        <router-link to="/free-music-for-livestreams">Livestreams</router-link>
        <router-link to="/free-music-for-vlogs">Vlogs</router-link>
        <router-link to="/free-anime-music">Anime</router-link>
        <router-link to="/free-christmas-music">Christmas</router-link>
      </div>
      <div class="footer-guides text-center mb-3" aria-label="Tools">
        <span>Tools:</span>
        <a href="/tools/referral-link-finder">Referral Code &amp; Link Finder</a>
      </div>
      <div
        class="bottom-links d-md-flex my-4 justify-content-between flex-wrap text-center"
        aria-label="Trust and policy links"
      >
        <div
          class="order-1 order-md-2 mb-4 mb-md-auto mt-md-auto px-1 pb-3 mx-auto"
        >
          <div class="row justify-content-center">
            <div class="col-auto">
              <router-link to="/license-terms">License Terms</router-link>
            </div>
            <div class="col-auto">
              <router-link to="/privacy-policy">Privacy Policy</router-link>
            </div>
            <div class="col-auto">
              <router-link to="/terms-of-use">Terms of Use</router-link>
            </div>
            <div class="col-auto">
              <router-link to="/contact-us">Contact</router-link>
            </div>
            <div class="col-auto">
              <router-link to="/privacy-policy">Privacy & Cookies</router-link>
            </div>
          </div>
        </div>
        <p class="order-2 order-md-1 my-auto pb-3 px-1 mx-auto">
          Viberary.com All Rights Reserved. Copyright &copy; {{ currentYear }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {currentYear: null}
  },
  created() {
    this.currentYear = new Date().getFullYear();
  },
}
</script>

<style scoped>
.footer-tagline,
.footer-guides {
  color: rgba(255,255,255,0.72);
  font-size: 13px;
  line-height: 1.5;
}
.footer-guides {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  justify-content: center;
}
.footer-guides span {
  color: rgba(255,255,255,0.52);
}
.footer-guides a {
  color: rgba(255,255,255,0.82);
  text-decoration: none;
}
.footer-guides a:hover {
  color: #ffd300;
}
</style>
